<!-- A summary carries formatting, drawn and typed into by its own field. -->
<app-report-rich-text
	*ngIf="field?.rich; else inline"
	[text]="text"
	[field]="field"
	[editorMode]="editorMode"
	[marks]="marks"
></app-report-rich-text>

<ng-template #inline>
	<!-- The cover's two-tone hero, while nobody is typing into it. -->
	<span
		*ngIf="decorated; else unmarked"
		class="inline-text"
		[class.inline-text--editable]="editable"
		[attr.tabindex]="editable ? 0 : null"
		[attr.role]="editable ? 'textbox' : null"
		[attr.aria-label]="editable ? field?.label : null"
		(mousedown)="open($event)"
		(focus)="open()"
	>
		{{ head }}
		<span class="inline-text__accent">{{ accent }}</span>
	</span>

	<!-- EDITOR ONLY: marked needs the flags only the editor has. The numbers
     the live data has moved on from, marked where they stand, and only drawn:
     a click opens the plain field in its place, as the hero above does. The
     runs are written as textContent, so no whitespace of this template gets
     into the text. -->
	<ng-template #unmarked>
		<span
			*ngIf="marked && !opened; else plain"
			class="inline-text inline-text--editable"
			[class.inline-text--multiline]="field?.multiline"
			tabindex="0"
			role="textbox"
			[attr.aria-label]="field?.label"
			(mousedown)="open($event)"
			(focus)="open()"
		>
			<ng-container *ngFor="let run of runs">
				<mark
					*ngIf="run.marked"
					class="inline-text__stale"
					[textContent]="run.text"
				></mark>
				<span *ngIf="!run.marked" [textContent]="run.text"></span>
			</ng-container>
		</span>
	</ng-template>

	<!-- No interpolation inside: see the component for why the text is written
     as textContent. -->
	<ng-template #plain>
		<span
			#input
			class="inline-text"
			[class.inline-text--multiline]="field?.multiline"
			[class.inline-text--editable]="editable"
			[class.inline-text--at-limit]="editing && atLimit"
			[textContent]="text"
			[attr.contenteditable]="editable ? editableMode : null"
			[attr.role]="editable ? 'textbox' : null"
			[attr.aria-label]="editable ? field?.label : null"
			[attr.aria-multiline]="editable ? !!field?.multiline : null"
			[attr.spellcheck]="editable ? 'true' : null"
			[attr.data-placeholder]="
				editable && placeholder ? placeholder : null
			"
			(focus)="onFocus()"
			(blur)="onBlur()"
			(keydown)="onKeydown($event)"
			(beforeinput)="onBeforeInput($event)"
			(input)="onInput()"
			(paste)="onPaste($event)"
		></span>
	</ng-template>

	<span
		*ngIf="showEdited && edited && !editing"
		class="inline-text__marker"
		matTooltip="You typed this. Ana keeps it unless you ask her to rewrite it."
		matTooltipPosition="above"
		matTooltipClass="sentiment-tooltip"
	>
		Edited
	</span>

	<span *ngIf="editing && atLimit" class="inline-text__limit">
		{{ limit }} characters at most
	</span>
</ng-template>

<app-report-figure-flags
	*ngIf="flagsShown"
	[place]="place"
></app-report-figure-flags>
